import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/document/document-ui.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/funding-progress-bar-complete-info/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/hydrate/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/ui/button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(business)/projects/[slug]/_components/_blocks/invest/_components/invest-cta/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(business)/projects/[slug]/_components/favorite/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(business)/projects/[slug]/_components/news/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(business)/projects/[slug]/_components/project-sections-client/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(business)/projects/[slug]/_components/register-banner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(business)/projects/[slug]/_components/share/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(business)/projects/[slug]/_components/stats/_blocks/operation/_components/capital-graph/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(business)/projects/[slug]/_components/strengths/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(business)/projects/[slug]/client-right-column.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/analytics/components/tracker/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["openIntercom"] */ "/app/src/lib/intercom/client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/lib/translation/components/link/index.tsx");
